import { render } from "./Forgot.vue?vue&type=template&id=4fa5fb94&scoped=true&ts=true"
import script from "./Forgot.vue?vue&type=script&lang=ts"
export * from "./Forgot.vue?vue&type=script&lang=ts"

import "./Forgot.vue?vue&type=style&index=0&id=4fa5fb94&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa5fb94"]])

export default __exports__